"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowTransformerValidator = void 0;

var lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));

var types_1 = require("../types");

var RowTransformerValidator = /*#__PURE__*/function () {
  function RowTransformerValidator() {
    _classCallCheck(this, RowTransformerValidator);

    this._rowTransform = null;
    this._rowValidator = null;
  } // eslint-disable-next-line @typescript-eslint/no-shadow


  _createClass(RowTransformerValidator, [{
    key: "rowTransform",
    set: function set(transformFunction) {
      if (!lodash_isfunction_1.default(transformFunction)) {
        throw new TypeError('The transform should be a function');
      }

      this._rowTransform = RowTransformerValidator.createTransform(transformFunction);
    }
  }, {
    key: "rowValidator",
    set: function set(validateFunction) {
      if (!lodash_isfunction_1.default(validateFunction)) {
        throw new TypeError('The validate should be a function');
      }

      this._rowValidator = RowTransformerValidator.createValidator(validateFunction);
    }
  }, {
    key: "transformAndValidate",
    value: function transformAndValidate(row, cb) {
      var _this = this;

      return this.callTransformer(row, function (transformErr, transformedRow) {
        if (transformErr) {
          return cb(transformErr);
        }

        if (!transformedRow) {
          return cb(null, {
            row: null,
            isValid: true
          });
        }

        return _this.callValidator(transformedRow, function (validateErr, validationResult) {
          if (validateErr) {
            return cb(validateErr);
          }

          if (validationResult && !validationResult.isValid) {
            return cb(null, {
              row: transformedRow,
              isValid: false,
              reason: validationResult.reason
            });
          }

          return cb(null, {
            row: transformedRow,
            isValid: true
          });
        });
      });
    }
  }, {
    key: "callTransformer",
    value: function callTransformer(row, cb) {
      if (!this._rowTransform) {
        return cb(null, row);
      }

      return this._rowTransform(row, cb);
    }
  }, {
    key: "callValidator",
    value: function callValidator(row, cb) {
      if (!this._rowValidator) {
        return cb(null, {
          row: row,
          isValid: true
        });
      }

      return this._rowValidator(row, cb);
    }
  }], [{
    key: "createTransform",
    value: function createTransform(transformFunction) {
      if (types_1.isSyncTransform(transformFunction)) {
        return function (row, cb) {
          var transformed = null;

          try {
            transformed = transformFunction(row);
          } catch (e) {
            return cb(e);
          }

          return cb(null, transformed);
        };
      }

      return transformFunction;
    }
  }, {
    key: "createValidator",
    value: function createValidator(validateFunction) {
      if (types_1.isSyncValidate(validateFunction)) {
        return function (row, cb) {
          cb(null, {
            row: row,
            isValid: validateFunction(row)
          });
        };
      }

      return function (row, cb) {
        validateFunction(row, function (err, isValid, reason) {
          if (err) {
            return cb(err);
          }

          if (isValid) {
            return cb(null, {
              row: row,
              isValid: isValid,
              reason: reason
            });
          }

          return cb(null, {
            row: row,
            isValid: false,
            reason: reason
          });
        });
      };
    }
  }]);

  return RowTransformerValidator;
}();

exports.RowTransformerValidator = RowTransformerValidator;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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